import type CK from '~/types/contentking';

import {
	useWebsiteIsIndexNowEnabledQuery,
} from './useWebsiteIsIndexNowEnabled.gql';

import useBatchContextWebsiteConfiguration from '~/hooks/useBatchContextWebsiteConfiguration';



function useWebsiteIsIndexNowEnabled(websiteId: CK.WebsiteId | null): boolean | null {
	const { data } = useWebsiteIsIndexNowEnabledQuery({
		context: useBatchContextWebsiteConfiguration(websiteId),
		skip: websiteId === null,
		variables: {
			websiteId: websiteId ?? '',
		},
	});

	return (data?.website?.isIndexNowEnabled) ?? null;
}



export default useWebsiteIsIndexNowEnabled;
